//src/api/homologation.js
import api from '.';

export const gerar = async (payload) => {
    try {
        const { data } = await api.post('homologation/item/gerar', payload);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const detalheItem = async (payload) => {
    try {
        const data = await api.post('homologation/item/detalheItem', payload);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const imprimirItensGeral = async (payload) => {
    try {
        const data = await api.post('homologation/item/imprimirItensGeral', payload, { responseType: 'arraybuffer' });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const imprimirItemDetalhe = async (payload) => {
    try {
        const data = await api.post('homologation/item/imprimirItemDetalhe', payload, { responseType: 'arraybuffer' });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const imprimirItemRegistro = async (payload) => {
    try {
        const data = await api.post('homologation/item/registro/imprimirItemRegistro', payload, { responseType: 'arraybuffer' });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
